import { IServiceCosmetologists, IServiceCosmetologistsListItem, ServiceCosmetologistsResponseType} from "@/entity/serviceCosmetologists/serviceCosmetologists.types";

export default class ServiceCosmetologists implements IServiceCosmetologists {
    total: number;
    data: IServiceCosmetologistsListItem[] = [];
    constructor(data: ServiceCosmetologistsResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}